import Welcome from './tabs/welcome/Welcome';
import Cashback from './tabs/cashback/Cashback';
import Promocode from './tabs/promocode/Promocode';
import PhoneBot from './tabs/phone_bot/PhoneBot';
import FreeSpin from './tabs/freespin/FreeSpin';
import Jackpots from './tabs/jackpots/Jackpots';
import { bonusInfoById, ENUM_BONUS_ID } from '../../../enums/MenuItems';
import StartBot from './tabs/start_bot/StartBot';

const elementById = {
  [ENUM_BONUS_ID.promocode]: Promocode,
  [ENUM_BONUS_ID.jackpots]: Jackpots,
  [ENUM_BONUS_ID.welcome]: Welcome,
  [ENUM_BONUS_ID.cashback]: Cashback,
  [ENUM_BONUS_ID.freespin]: FreeSpin,
  [ENUM_BONUS_ID.launch_bot]: StartBot,
  [ENUM_BONUS_ID.phone_bot]: PhoneBot
};

const getProfileTab = () => {
  let bonuses = [];
  for (let bonusId in ENUM_BONUS_ID) {
    const bonusInfo = bonusInfoById[bonusId];
    bonuses.push({
      label: bonusInfo.label,
      icon: <bonusInfo.icon size="20" />,
      id: bonusId,
      element: elementById[bonusId]
    });
  }

  return bonuses;
};

export const ProfileTabs = getProfileTab();
